import { render, staticRenderFns } from "./NormalSearchNav246.vue?vue&type=template&id=a4fab146&scoped=true&"
import script from "./NormalSearchNav246.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav246.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4fab146",
  null
  
)

export default component.exports